import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

import {Image, PageHelper, } from '../../../../common/services';
import {ImageBlock, ImageValue, Layout, Size, typeLayout, typeSize} from '../../../../common/services/page';
import {SelectMediaModalComponent} from './select-media-modal/select-media-modal.component';


@Component({
  selector: 'p8-bdc-edit-image',
  templateUrl: './edit-image.component.html',
  styleUrls: ['./edit-image.component.scss']
})
export class EditImageComponent implements OnInit {
  @Input() block: ImageBlock;
  /**
   * action : add ou del
   * @type {EventEmitter<any>} {block: block, action: 'add'}
   */
  @Output() blockChange: EventEmitter<any> = new EventEmitter();

  constructor(private dialog: MatDialog, private pageHelper: PageHelper) { }

  ngOnInit() {
  }

  calculateUrl(block: ImageBlock) {
    let img: string | File = '';
    if (this.pageHelper) {
      img = this.pageHelper.calculeUrlImage(block);
      return img;
    }

    return '';
  }

  hasImage() {
    if (this.block && this.block.value && this.block.value.file) {
      return true;
    }

    return false;
  }

  openMedias() {
    const modal = this.dialog.open(SelectMediaModalComponent, );
    modal.updatePosition({top: '50px'});
    modal.updateSize('1200px');

    modal.afterClosed().subscribe((image: Image) => {
      if (image && typeLayout && typeSize) {
        console.log('image ', image);

        const layout: Layout = <Layout> {
          position: typeLayout.center
        };

        const size: Size = <Size> {
          size: typeSize.o
        };

        this.block.value = <ImageValue> {
          imageId: image.id,
          layout: layout,
          size: size,
          file: image.file
        };

        this.blockChange.emit({block: this.block, image: image, action: 'add'});
      }
    });
  }
}
